import { Styles } from '@chakra-ui/theme-tools'

export const globalStyles: Styles = {
  global: {
    html: {
      fontSize: '18px',
    },
    body: {
      backgroundColor: 'white',
      width: '100vw',
      height: '100dvh',
      margin: '0',
      padding: '0',
      color: 'gray.800',
    },
  },
}
